import React from "react";
import DataFetcherTemplateHome from "../../hooks/DataFetcherTemplateHome";

const BASE_URL = "https://be-ofertas.utpl.edu.ec/";

// 1. Construcción limpia de la URL de Drupal JSON:API
const endpoint = new URL(
  "jsonapi/node/template_home/8d79aff7-681f-4fa5-abaa-bd7557bcbe50",
  BASE_URL
);
endpoint.searchParams.set(
  "include",
  "field_imagen_portada.field_media_image,field_gallery.field_media_image,field_imagen1.field_media_image,field_imagen2.field_media_image,field_imagen3.field_media_image,field_imagen4.field_media_image,field_imagen5.field_media_image"
);
endpoint.searchParams.set(
  "fields[node--template_home]",
  "title,field_gallery,field_imagen_portada,field_imagen1,field_imagen2,field_imagen3,field_imagen4,field_imagen5,field_texto_portada,field_bloque1,field_bloque2,field_bloque3,field_bloque4,field_bloque5,field_bloque6,field_bloque7,field_bloque8,field_bloque9"
);
endpoint.searchParams.set("fields[media--image]", "field_media_image");
endpoint.searchParams.set("fields[file--file]", "uri");

const url = endpoint.toString();

// 2. Sanitizador / transformador de rutas de imágenes compatible con SSR
const processContent = (html = "") => {
  if (typeof window === "undefined" || !html) return html;

  try {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");

    doc.querySelectorAll("img").forEach((img) => {
      const src = img.getAttribute("src");
      if (src && !src.startsWith("http")) {
        try {
          img.setAttribute("src", new URL(src, BASE_URL).href);
        } catch {
          // Conserva el src original si la URL es inválida
        }
      }
    });

    return doc.body.innerHTML;
  } catch {
    return html;
  }
};

// 3. Estilos centralizados para cada tarjeta
const CARD_STYLES = {
  container:
    "relative min-h-[300px] rounded-lg overflow-hidden flex items-center justify-center p-4",
  image: "absolute inset-0 w-full h-full object-cover",
  overlay: "absolute inset-0 bg-black/40",
  content:
    "relative z-10 text-center text-white [&_p]:text-white max-w-full",
};

// 4. Componente SeccionBloques dinámico
export function SeccionBloques({ data }) {
  if (!data) return null;

  const indices = [3, 4, 5, 6, 7,8];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-6 gap-4">
      {indices.map((num) => {
        const contenido = data[`bloque${num}`];
        const imagen = data[`imagen${num}`];

        if (!contenido) return null;

        return (
          <div key={num} className={CARD_STYLES.container}>
            {imagen && (
              <img
                src={imagen}
                alt={`Contenido institucional ${num} - UTPL`}
                className={CARD_STYLES.image}
                loading="lazy"
              />
            )}

            <div className={CARD_STYLES.overlay} />

            <div
              className={CARD_STYLES.content}
              dangerouslySetInnerHTML={{
                __html: processContent(contenido),
              }}
            />
          </div>
        );
      })}
    </div>
  );
}

// 5. Componente DataDisplay simplificado llamando a SeccionBloques
function DataDisplay({ data }) {
  if (!data) return null;

  return (
    <div>
      {data.bloque1 && (
        <div
          className="max-w-3xl mx-auto mt-10"
          dangerouslySetInnerHTML={{
            __html: processContent(data.bloque1),
          }}
        />
      )}

 {/*      <section className="py-16 bg-slate-50">
        <div className="max-w-6xl m-auto px-6 sm:px-0">
          {data.bloque2 && (
            <div
              className="text-center max-w-3xl m-auto mb-10"
              dangerouslySetInnerHTML={{
                __html: processContent(data.bloque2),
              }}
            />
          )}

       
          <SeccionBloques data={data} />
        </div>
      </section> */}
    </div>
  );
}

// 6. Home principal
function Home() {
  return (
    <DataFetcherTemplateHome url={url}>
      {(data) => <DataDisplay data={data} />}
    </DataFetcherTemplateHome>
  );
}

export default Home;